var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _c(
        "md-switch",
        {
          staticClass: "ui-switch",
          class: { "ui-switch--large": _vm.large },
          attrs: { disabled: _vm.disabled, value: !_vm.value },
          on: {
            change: function () {
              _vm.$emit("input", !_vm.value)
              _vm.$emit("change", !_vm.value)
            },
          },
        },
        [_vm._v("\n\t\t" + _vm._s(_vm.label) + "\n\t")]
      ),
      _vm._v(" "),
      _vm.tooltip ? _c("md-tooltip", [_vm._v(_vm._s(_vm.tooltip))]) : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }